import createIcon from '../../createIcon';

/**
 * @component @name Api
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgMTJMMTIgMTRMMTAgMTJMMTIgMTBMMTQgMTJaTTEyIDZMMTQuMTIgOC4xMkwxNi42MiA1LjYyTDEyIDFMNy4zOCA1LjYyTDkuODggOC4xMkwxMiA2Wk02IDEyTDguMTIgOS44OEw1LjYyIDcuMzhMMSAxMkw1LjYyIDE2LjYyTDguMTIgMTQuMTJMNiAxMlpNMTggMTJMMTUuODggMTQuMTJMMTguMzggMTYuNjJMMjMgMTJMMTguMzggNy4zOEwxNS44OCA5Ljg4TDE4IDEyWk0xMiAxOEw5Ljg4IDE1Ljg4TDcuMzggMTguMzhMMTIgMjNMMTYuNjIgMTguMzhMMTQuMTIgMTUuODhMMTIgMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Api = createIcon('Api', [
  [
    'path',
    {
      d: 'M14 12L12 14L10 12L12 10L14 12ZM12 6L14.12 8.12L16.62 5.62L12 1L7.38 5.62L9.88 8.12L12 6ZM6 12L8.12 9.88L5.62 7.38L1 12L5.62 16.62L8.12 14.12L6 12ZM18 12L15.88 14.12L18.38 16.62L23 12L18.38 7.38L15.88 9.88L18 12ZM12 18L9.88 15.88L7.38 18.38L12 23L16.62 18.38L14.12 15.88L12 18Z',
      key: 'duwuz9',
    },
  ],
]);

export default Api;
